<template src="./recover.html"></template>

<script>

import {API_URL} from '@/main'
import axios from "axios"
import router from '@/router/index.js'

export default {
  name: "RecoverPassword",
  data() {
    return {
      username: '',
      show_alert: false,
    }
  },
  mounted() {

  },
  methods: {
    async execute_recover() {

      const url = API_URL+"login/Recover/"
      const data = {
        username: this.username,
      }
      const response = await axios.post(url, data)
      this.show_alert = true
    },
    goto_register() {

      router.push({path: "/register"})
    },
  },
}

</script>